export default __webpack_public_path__ + "static/media/quiz-pic-8.db037e82.jpeg";